// extracted by mini-css-extract-plugin
export default {"desktop-navigation":"DesktopNavigation_desktop-navigation__5G8bW"};